import { faPencil, faPlus } from '@fortawesome/pro-solid-svg-icons';
import BreadcrumbItem from 'Components/Atoms/BreadcrumbItem/BreadcrumbItem';
import Button from 'Components/Atoms/Button/Button';
import FontAwesomeIcon from 'Components/Atoms/FontAwesomeIcon/FontAwesomeIcon';
import Grid from 'Components/Atoms/Grid/Grid';
import Spinner from 'Components/Atoms/Spinner/Spinner';
import Title from 'Components/Atoms/Title/Title';
import Breadcrumbs from 'Components/Molecules/Breadcrumbs/Breadcrumbs';
import Table from 'Components/Molecules/Table/Table';
import TableBody from 'Components/Molecules/TableBody/TableBody';
import TableCell from 'Components/Molecules/TableCell/TableCell';
import TableColumn from 'Components/Molecules/TableColumn/TableColumn';
import TableHeader from 'Components/Molecules/TableHeader/TableHeader';
import TableRow from 'Components/Molecules/TableRow/TableRow';
import ActivateModule from 'Components/Organisms/Settings/Modules/ActivateModule';
import ContactModuleItem from 'Components/Organisms/Settings/Modules/ContactModule/ContactModuleItem';
import SettingsTemplate from 'Components/Templates/Page/Settings/SettingsTemplate';
import React, { Suspense, useEffect, useMemo, useState } from 'react';
import 'react-dual-listbox/lib/react-dual-listbox.css';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { ROUTES } from 'Services/Route/Route.types';
import EntityHelper from 'Services/Settings/Entity/EntityHelper';
import { StoreState } from 'Store/Reducers';
import { fetchEntities, patchEntity } from 'Store/Settings/Entities/Actions';
import { getEntitiesById, isEntityLoading, isEntityPatching } from 'Store/Settings/Entities/Selectors';
import { getEntityTypesByIdAsObject } from 'Store/Settings/EntityTypes/Selector';
import { fetchFields } from 'Store/Settings/Fields/Actions';
import { getFieldsById, isFieldsLoading } from 'Store/Settings/Fields/Selectors';
import { fetchLayouts } from 'Store/Settings/Layout/Actions';
import { getLayoutsByEntityIdAsObject, getLayoutsByEntityTypeIdAsObject, getLayoutsById, isLayoutDeleting, isLayoutLoading } from 'Store/Settings/Layout/Selectors';
import { fetchModules } from 'Store/Settings/Modules/Actions';
import { getModulesByEntityIdByModule } from 'Store/Settings/Modules/Selectors';

const ContactModuleCreateLabel = React.lazy(() => import('Components/Organisms/Settings/Modules/ContactModule/ContactModuleCreateLabel'));

const LayoutPage = ({
    isLoading, isPatching, isDeleting,
    entitiesById, entityTypesById,
    layoutsByEntityTypeId,
    layoutsAsObject, allLayouts, fieldsById,


    moduleByEntityIdByModuleId,

    ...props
}: LayoutPageProps) => {
    const {
        entity_id,
        type_id
     } = useParams<{
        entity_id: string
        type_id: string
    }>();
    const [state, setState] = useState({
        isEdit: false,
        isLoading: false,
        isCreateModalOpen: false
    });

    const handleCreateModal = () => setState((state) => ({
        ...state,
        isCreateModalOpen: !state.isCreateModalOpen
    }));
    
    useEffect(() => {
        props.fetchEntities();
        props.fetchModules();
        props.fetchLayouts();
        props.fetchFields();
        // props.fetchEntityTypesByEntityId(entity_id);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!isPatching) {
            setState((state) => ({
                ...state,
                isEdit: false
            }));
        }
    }, [isPatching]);

    const entity = useMemo(() => {
        if (entity_id) {
            return {
                ...entitiesById?.[entity_id],
                formattedName: EntityHelper.getDisplayValueByName(entitiesById?.[entity_id]?.name)
            };
        }

        return {};
    }, [entitiesById, entity_id]);

    return <SettingsTemplate
        breadcrumbs={
            <Breadcrumbs>
                <BreadcrumbItem size='small' path={ROUTES.SETTINGS.path}>Instellingen</BreadcrumbItem>
                <BreadcrumbItem size='small' path={ROUTES.SETTINGS.ENTITIES.getFullPath()}>Entiteiten</BreadcrumbItem>
                <BreadcrumbItem size='small' path={ROUTES.SETTINGS.ENTITIES.ENTITY.getFullPath(entity?.id)}>{entity?.formattedName || 'Oops...'}</BreadcrumbItem>
                <BreadcrumbItem size='small' path={ROUTES.SETTINGS.ENTITIES.ENTITY.MODULES.getFullPath(entity?.id)}>Modules</BreadcrumbItem>
                <BreadcrumbItem size='small'>Contactgegevens</BreadcrumbItem>
            </Breadcrumbs>
        }
        description={`Instellingen voor de layout van ${(entity?.formattedName || 'oops...')}`}
    >
        { state.isLoading &&
            <Grid position='centered'>
                <Spinner />
                <Title size='small' weight='semibold'>Entiteiten laden...</Title>
            </Grid>
        }
        { !state.isLoading
        && !entity?.id
        &&  <Grid position='centered'>
                <Title size='small' weight='semibold'>Geen entiteit gevonden met de volgende id: {type_id}</Title>
            </Grid>
        }

        { entity?.id
        && <Grid axis='vertical'>
            <ActivateModule
                moduleId='contact'
                entity_id={entity?.id}
            />

            <br/>

            <Suspense>
                {
                    state.isCreateModalOpen
                    && <ContactModuleCreateLabel
                        onClose={handleCreateModal}
                        entity_id={entity_id}
                    />
                }
            </Suspense>

            <Grid axis='horizontal' position='between'>
                <Title size='small' weight='semibold'>Afdeling voor labels</Title>
            </Grid>

            <Table>
                <TableHeader>
                    <TableColumn>
                        Naam
                    </TableColumn>
                </TableHeader>
                <Button
                    size='small'
                    iconBefore={<FontAwesomeIcon icon={faPlus} />}
                    onClick={handleCreateModal}
                >
                    Toevoegen
                </Button>
                <TableBody>
                    {/* <TableRow>
                        <TableCell>
                            <Button
                                size='small'
                                iconBefore={<FontAwesomeIcon icon={faPencil} />}
                                onClick={handleCreateModal}
                            >
                                Toevoegen
                            </Button>
                        </TableCell>
                    </TableRow> */}

                    {
                        moduleByEntityIdByModuleId
                        ?.[entity.id]
                        ?.['contact']
                        ?.configuration
                        ?.labels
                        ?.map(i => <ContactModuleItem
                            key={i?.id}
                            id={i?.id}
                            name={i?.name}
                            entity_id={entity.id}
                        />)
                    }
                </TableBody>
            </Table>
        </Grid>
        }
    </SettingsTemplate>;
}

interface Props {

}

const mapState = (state: StoreState) => ({
    entitiesById: getEntitiesById(state),
    isLoading: isEntityLoading(state) || isLayoutLoading(state) || isFieldsLoading(state),
    // isPatching: isLayoutPatching(state),
    isDeleting: isLayoutDeleting(state),
    layoutsAsObject: getLayoutsByEntityIdAsObject(state),
    allLayouts: getLayoutsById(state),
    fieldsById: getFieldsById(state),

    layoutsByEntityTypeId: getLayoutsByEntityTypeIdAsObject(state),
    entityTypesById: getEntityTypesByIdAsObject(state),

    isPatching: isEntityPatching(state),
    moduleByEntityIdByModuleId: getModulesByEntityIdByModule(state)
});

const mapDispatch = {
    fetchEntities,
    fetchLayouts,
    fetchFields,
    fetchModules,

    patchEntity
}

type LayoutPageProps = Props & ReturnType<typeof mapState> & typeof mapDispatch;

export default connect(mapState, mapDispatch)(LayoutPage);